/**
 * Created on 2021/3/30.
 */
import Store from '../vuex/store';
import Router from '../router/index';
import {fetchReceiverIm} from "../api/xunyou";
const $IM_URL = 'https://im.r-e-go.com/index';

const tools = {
  /**/
  showGoodInBlank (id) {
    const routeUrl = Router.resolve({
      path: '/goodsdetail',
      query: {id}
    });
    window.open(routeUrl.href, '_blank');
  },
  /**
   * 判断是否登录，并做相应处理
   * @param callback
   */
  isLogin (callback) {
    if (Store.getters.isLogin) {
      callback && callback();
    } else {
      Router.push('/login');
    }
  },
  /**
   * 唤起客服系统
   * @param targetId 目标好友ID
   * @param type PLAT/MER/USER
   */
  contactService (targetId, type = 'PLAT') {
    tools.isLogin(async () => {
      let rcUid = null;
      const rcRes = await fetchReceiverIm({uid: targetId || '', uType: type});
      if (rcRes.code === 0) rcUid = rcRes.data;
      if (Store.getters.imToken) {
        window.open(`${$IM_URL}?tk=${Store.getters.imToken}&rsr=${rcUid}`);
      }
    });
  },
  /**
   * @description 生成全局唯一ID
   * @return {string}
   */
  generateUUID () {
    const s = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';

    return s.join('');
  }
}

export default tools;



// WEBPACK FOOTER //
// ./src/utils/tools.js